export const EnvironmentsHosts = {
    LOCAL: 'localhost:3000',
    STAGING: 'v2staging.sense.network',
    PRODUCTION: 'its.sense.education',
}

export const environmentToClarityProjectId = environment => {
    const mapping = {
        [EnvironmentsHosts.STAGING]: 'f91ljbumb8',
        [EnvironmentsHosts.PRODUCTION]: 'f8xz2yodqy',
    }

    return mapping[environment] || 'UNKNOWN_ENVIRONMENT'
}
